<template>
    <b-modal title="Speaker Consolidation"
             size="xl"
             body-class="p-0"
             centered
             no-close-on-backdrop
             v-model="dialogOpen"
             @shown="onDialogShown"
             @hidden="onDialogHidden"
             ignore-enforce-focus-selector=".e-dlg-container.e-edit-dialog select, .e-dlg-container.e-edit-dialog input">
        <ejs-grid ref="speakerConsolidationGrid" 
                  :dataSource="gridData"
                  :editSettings='editSettings'
                  :allowSorting='true'
                  :sortSettings='sortSettings'
                  :allowSelection='true'
                  :selectionSettings='selectionSettings'
                  :rowSelecting="rowSelecting"
                  :actionComplete="actionComplete">
            <e-columns>
                <e-column field='SpeakerId' :visible="false" :isPrimaryKey='true'></e-column>
                <e-column type='checkbox' :allowFiltering='false' :allowSorting='false' :allowEditing="false" width="5%"></e-column>
                <e-column field='Title' headerText='Title' editType='dropdownedit' :edit='titleEditParams' width="13%"></e-column>
                <e-column field='Surname' headerText='Surname'></e-column>
                <e-column field='OtherNames' headerText='Other Names'></e-column>
                <e-column field='HonorificTitle' headerText='Hon. Title' editType='dropdownedit' :edit='honorificTitleEditParams' width="16%"></e-column>
                <e-column field='SubType' headerText='Type' editType='dropdownedit' :edit='speakerTypeEditParams' template="speakerTypeColumnTemplate" width="16%"></e-column>
            </e-columns>
            <template v-slot:speakerTypeColumnTemplate="{data}">
                {{ getSpeakerTypeText(data.SubType) }}
            </template>
        </ejs-grid>

        <template v-if="consolidating" v-slot:modal-footer>
            <span>Select the speaker to keep</span>
            <b-button @click="cancelConsolidation">Cancel</b-button>
            <b-button variant="success"
                      @click="confirmConsolidate">Confirm</b-button>
        </template>

        <template v-else v-slot:modal-footer="{ cancel }">
            <b-button @click="cancel">Cancel</b-button>
            <b-button variant="danger" @click="reset">Reset</b-button>
            <b-button variant="primary"
                      @click="consolidate">Consolidate</b-button>
            <b-button variant="success"
                      @click="saveAndExit">Save & Exit</b-button>
        </template>

    </b-modal>
</template>

<script>
    import Vue from 'vue';
    import BootstrapVue from 'bootstrap-vue';
    
    import { Filter, Edit, Sort, Page, Toolbar } from '@syncfusion/ej2-vue-grids';
    import { Query } from "@syncfusion/ej2-data";

    Vue.use(BootstrapVue);

    export default {
        name: 'TopscribeSpeakerConsolidationDialog',
        provide: {
            grid: [Edit, Page, Toolbar, Sort, Filter]
        },
        model: {
            event: 'change',
            prop: 'active',

        },
        props: {
            speakerConfiguration: {
                type: Object,
                default: null
            },
            speakerSectionDetails: {
                type: Array,
                default: null
            },
            active: {
                type: Boolean,
                default: false
            },
            
        },
        data: function () {
            return {
                dialogOpen: this.active,
                
                grid: null,
                gridData: [],
                editSettings: { allowEditing: true, allowAdding: false, allowDeleting: true, mode: 'Dialog' },
                sortSettings: { columns: [{ field: "SubType", direction: "Ascending" }, { field: "Surname", direction: "Ascending" }, { field: "OtherNames", direction: "Ascending" }] },
                selectionSettings: { type: 'Multiple' },
                
                speakerTypeSelectionOptions: null,
                consolidationList: [],
            }
        },
        computed: {
            titleOptions: function () {
                if (this.speakerConfiguration == null) return null;
                //we would now usually return the list of honorific Titles (just a list of strings) from the configuration - loaded from the API, but as this is a sample i will generate them as a static array

                // return ['QC', 'SC', 'MP'];

                var options = [
                    { text: 'n/a', value: '' },
                    { text: 'MR', value: 'MR' },
                    { text: 'MS', value: 'MS' },
                    { text: 'DR', value: 'DR' },
                    { text: 'PROF', value: 'PROF' }
                ];
                return options;
            },
            titleEditParams: function () {
                return {
                    params: {
                        allowFiltering: false,
                        dataSource: this.titleOptions,
                        fields: { text: "text", value: "value" },
                        sortOrder: "None",
                        query: new Query(),
                        actionComplete: () => false,
                    }
                };
            },

            honorificTitleOptions: function () {
                if (this.speakerConfiguration == null) return null;
                //we would now usually return the list of honorific Titles (just a list of strings) from the configuration - loaded from the API, 
                // but as this is a sample i will generate them as a static array

                var options = [
                    { text: 'n/a', value: '' },
                    { text: 'DCJ', value: 'DCJ' },
                    { text: 'QC', value: 'QC' },
                    { text: 'SC', value: 'SC' },
                    { text: 'MP', value: 'MP' },
                    { text: 'KC', value: 'KC' }
                ];
                return options;
            },
            honorificTitleEditParams: function () {
                return {
                    params: {
                        allowFiltering: false,
                        dataSource: this.honorificTitleOptions,
                        fields: { text: "text", value: "value" },
                        sortOrder: "None",
                        query: new Query(),
                        actionComplete: () => false,
                    }
                };
            },

            speakerTypeOptions: function () {
                if (this.speakerConfiguration == null) return null;
                var options = [];
                this.speakerConfiguration.SpeakerGroupOptions.forEach(sgo => {
                    sgo.value.SpeakerTypeOptions.forEach(sto => {
                        options.push({
                            text: sto.text,
                            value: sto.value.SpeakerType
                        });
                    });
                });
                return options;
            },
            speakerTypeEditParams: function () {
                return {
                    params: {
                        allowFiltering: false,
                        dataSource: this.speakerTypeOptions,
                        fields: { text: "text", value: "value" },
                        sortOrder: "None",
                        query: new Query(),
                        actionComplete: () => false,
                    }
                };
            },

            consolidating: function () {
                return this.consolidationList.length > 0;
            },
            
        },
        watch: {
            active: function () {
                if (this.active) {
                    this.reset();
                }
                this.dialogOpen = this.active;
            },
        },
        methods: {
            getSpeakerTypeText: function (speakerTypeValue) {
                if (this.speakerTypeOptions) {
                    var speakerTypeOption = this.speakerTypeOptions.find(e => e.value == speakerTypeValue);
                    if (speakerTypeOption) return speakerTypeOption.text;
                }
                return speakerTypeValue;
            },
            rowSelecting: function (args) {
                if (this.consolidating) {
                    if (this.grid.getSelectedRecords().length) this.grid.clearSelection();
                    if (!this.consolidationList.find(e => e.SpeakerId == args.data.SpeakerId)) args.cancel = true;
                }
            },
            actionComplete: function(args) {
                if (args.requestType === 'beginEdit') {
                    args.dialog.header = 'Edit Speaker';
                }
            },
            consolidate: function () {
                this.consolidationList = this.grid.getSelectedRecords();
                if (this.consolidationList && (this.consolidationList.length > 1)) {
                    for (var i = 0; i < this.grid.getSelectedRows().length; i++) {
                        this.grid.getSelectedRows()[i].classList.add('consolidating');
                    }
                    this.grid.clearRowSelection();
                } else {
                    this.consolidationList = [];
                    this.$bvToast.toast('At least two speakers have to be selected', {
                        title: 'Invalid Selection',
                        variant: 'danger',
                        appendToast: true
                    });
                }
            },
            confirmConsolidate: function () {
                var selectedRecords = this.grid.getSelectedRecords();
                if (selectedRecords && (selectedRecords.length == 1)) {
                    var recordToKeep = selectedRecords[0];
                    var recordToKeepIndex = this.consolidationList.findIndex(c => c.SpeakerId == recordToKeep.SpeakerId);
                    this.consolidationList.splice(recordToKeepIndex, 1);
                    var rowIndicesToDelete = [];
                    this.consolidationList.forEach(e => {
                        recordToKeep.SectionId = recordToKeep.SectionId.concat(e.SectionId);
                        rowIndicesToDelete.push(this.grid.getRowIndexByPrimaryKey(e.SpeakerId));
                    })
                    this.consolidationList = [];
                    this.grid.selectRows(rowIndicesToDelete);
                    this.grid.deleteRecord();
                } else {
                    this.$bvToast.toast('You have to select the speaker to keep', {
                        title: 'Invalid Selection',
                        variant: 'danger',
                        appendToast: true
                    });
                }
            },
            cancelConsolidation: function () {
                this.consolidationList = [];
                for (var i = 0; i < this.grid.getAllDataRows().length; i++) {
                    this.grid.getAllDataRows()[i].classList.remove('consolidating');
                }
                this.grid.clearRowSelection();
            },
            speakerFullname: function (speaker) {
                var fullName = '';
                if (speaker.Title != null) {
                    fullName += speaker.Title;
                }
                fullName = fullName.trim();
                if (speaker.Surname != null) {
                    fullName += ' ';
                    fullName += speaker.Surname;
                }
                fullName = fullName.trim();
                if (speaker.OtherNames != null) {
                    fullName += ' ';
                    fullName += speaker.OtherNames;
                }
                fullName = fullName.trim();
                if (speaker.HonorificTitle != null) {
                    fullName += ' ';
                    fullName += speaker.HonorificTitle;
                }
                fullName = fullName.trim();
                return fullName;
            },
            reset: function () {
                this.gridData = [];
                if (this.speakerSectionDetails != null) {
                    for (var i = 0; i < this.speakerSectionDetails.length; i++) {
                        var base64EncodedMetaData = this.speakerSectionDetails[i].metaData;
                        var metaData = JSON.parse(atob(base64EncodedMetaData));

                        var existingIndex = this.gridData.findIndex(e => e.SpeakerId == metaData.SpeakerId);
                        if (existingIndex < 0)
                            existingIndex = this.gridData.findIndex(e =>
                                (e.Title == metaData.Title) &&
                                (e.Surname == metaData.Surname) &&
                                (e.OtherNames == metaData.OtherNames) &&
                                (e.HonorificTitle == metaData.HonorificTitle) &&
                                (e.SubType == metaData.SubType));
                        if (existingIndex >= 0)
                            this.gridData[existingIndex].SectionId.push(metaData.SectionId);
                        else
                            this.gridData.push({ ...metaData, SectionId: [metaData.SectionId] });
                    }
                }
            },
            saveAndExit: function () {
                var newSectionDetails = [];
                var dataRows = this.grid.dataSource;
                
                for (var i = 0; i < dataRows.length; i++) {
                    for (var j = 0; j < dataRows[i].SectionId.length; j++) {
                        var metaData = { ...dataRows[i], SectionId: dataRows[i].SectionId[j] };
                        var item = {
                            content: null,
                            marginText: this.speakerFullname(dataRows[i]),
                            metaData: btoa(JSON.stringify(metaData)),
                            sectionId: dataRows[i].SectionId[j],
                            sectionSubType: dataRows[i].SubType,
                            sectionType: "speaker"
                        }
                        newSectionDetails.push(item);
                    }
                }
                this.$emit('speakerDataChanged', newSectionDetails);
                this.dialogOpen = false;
            },
            onDialogShown: function () {
                if (this.$refs.speakerConsolidationGrid) this.grid = this.$refs.speakerConsolidationGrid.ej2Instances;
            },
            onDialogHidden: function () {
                this.gridData = [];
                this.$emit('change', false);
            }
        }
    }
</script>


<style>
    .consolidating {
        background-color: #8ac4ff !important;
    }
</style>